"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.faqsNormalizer = void 0;
const mocks_json_1 = __importDefault(require("./mocks.json"));
/**
 * normalizador del modulo FAQS_PREGUNTAS_FRECUENTES_FIBRA_600MB_NEW
 * @param {object} fields
 * @returns
 */
const faqsNormalizer = (data) => {
    var _a, _b;
    try {
        let res = null;
        const title = (_a = data === null || data === void 0 ? void 0 : data.fields) === null || _a === void 0 ? void 0 : _a.title;
        const listadoFAQS = (_b = data === null || data === void 0 ? void 0 : data.fields) === null || _b === void 0 ? void 0 : _b.listadoFAQS;
        if (listadoFAQS && Array.isArray(listadoFAQS) && listadoFAQS.length > 0) {
            const normalizedInfo = {};
            if (title) {
                normalizedInfo["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { text: title });
            }
            listadoFAQS.map((faq, index) => {
                const { fields } = faq;
                if ((fields === null || fields === void 0 ? void 0 : fields.title) && (fields === null || fields === void 0 ? void 0 : fields.description)) {
                    normalizedInfo[`Faq-${index + 1}`] = {
                        title: fields.title,
                        description: fields.description,
                    };
                }
            });
            res = normalizedInfo;
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.faqsNormalizer = faqsNormalizer;
exports.default = exports.faqsNormalizer;
//# sourceMappingURL=index.js.map